<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.trayInspection_ExpectedColor"
      >
        <span class="col-form-label">Color and Width of banding is whats expected</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.trayInspection_PrePrintedMarkings"
      >
        <span class="col-form-label">Preprinted Markings</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.trayInspection_Oriented">
        <span class="col-form-label">Trays oriented in same way</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.trayInspection_TopTray">
        <span class="col-form-label">Top tray to protect parts</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.trayInspection_AntiStaticCover"
      >
        <span class="col-form-label">Covered by cardboard / antistatic</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.trayInspection_ChipOrientation"
      >
        <span class="col-form-label">Chip orientation in tray is consistent</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaTrays',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        trayInspection_ExpectedColor: this.inspectionDetails[FIELDS.TRAY_INSPECTION__EXPECTED_COLOR] || '',
        trayInspection_PrePrintedMarkings: this.inspectionDetails[FIELDS.TRAY_INSPECTION__PRE_PRINTED_MARKINGS] || '',
        trayInspection_Oriented: this.inspectionDetails[FIELDS.TRAY_INSPECTION__ORIENTED] || '',
        trayInspection_TopTray: this.inspectionDetails[FIELDS.TRAY_INSPECTION__TOP_TRAY] || '',
        trayInspection_AntiStaticCover: this.inspectionDetails[FIELDS.TRAY_INSPECTION__ANTI_STATIC_COVER] || '',
        trayInspection_ChipOrientation: this.inspectionDetails[FIELDS.TRAY_INSPECTION__CHIP_ORIENTATION] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>